var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBottomtabActivityInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9225 2.23129C17.7992 2.1288 17.6531 2.05745 17.4965 2.02326C17.3399 1.98906 17.1773 1.99303 17.0225 2.03481C16.8678 2.0766 16.7253 2.15499 16.6072 2.26337C16.489 2.37174 16.3987 2.50693 16.3438 2.65754L13.5938 10.2088L10.5737 7.28254C10.4723 7.18417 10.3512 7.10841 10.2184 7.06025C10.0856 7.01209 9.94403 6.99263 9.80313 7.00314C9.66223 7.01365 9.52516 7.0539 9.40095 7.12123C9.27674 7.18857 9.1682 7.28146 9.0825 7.39379C6.375 10.9413 5 14.51 5 18C5 20.9174 6.15893 23.7153 8.22183 25.7782C10.2847 27.8411 13.0826 29 16 29C18.9174 29 21.7153 27.8411 23.7782 25.7782C25.8411 23.7153 27 20.9174 27 18C27 10.5688 20.6513 4.50004 17.9225 2.23129ZM16 27C13.6139 26.9974 11.3262 26.0483 9.63896 24.3611C7.95171 22.6738 7.00265 20.3862 7 18C7 15.25 8.01125 12.4013 10.0075 9.52004L13.3038 12.7175C13.4235 12.8338 13.5704 12.9183 13.7311 12.9632C13.8918 13.0082 14.0612 13.0122 14.2238 12.9749C14.3865 12.9376 14.5372 12.8602 14.6623 12.7498C14.7874 12.6393 14.8829 12.4993 14.94 12.3425L17.7237 4.70879C20.5262 7.26004 25 12.2388 25 18C24.9974 20.3862 24.0483 22.6738 22.361 24.3611C20.6738 26.0483 18.3861 26.9974 16 27Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBottomtabActivityInactive);
export default __webpack_public_path__ + "static/media/icon_bottomtab_activity_inactive.c2beb76c25c7f31419231cd073eab2f9.svg";
export { ForwardRef as ReactComponent };